module.exports = __webpack_public_path__ + "static/media/mask-pink.fd694f86.png";